import React, { useState } from "react";
import styled from "styled-components";
import { BoxedStyled, FlowStyled } from "../../../../style/components/common.styled";
import { EuiButton, EuiFieldText, EuiFormRow, EuiIcon } from "@elastic/eui";
import { useHistory } from "react-router-dom";
import { addToast } from '../../../components/toasts/Toast';
import mongoDbStore from "../../../../stores/mongodb.store";

const BoxedStyledOwn = styled(BoxedStyled)`
  background: transparent;
  box-shadow: none;
  margin: 0;
  padding: 0;
  width: 100%;

  &:hover {
    box-shadow: none;
    transform: none;
  }
`;

const SetupGridStyled = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 0.9fr) minmax(320px, 1fr);
  gap: 16px;

  @media (max-width: 900px) {
    grid-template-columns: 1fr;
  }
`;

const FormCardStyled = styled.section`
  background: linear-gradient(135deg, rgb(35, 37, 47) 0%, rgb(24, 25, 30) 100%);
  border: 1px solid rgba(255, 255, 255, 0.06);
  border-radius: 8px;
  padding: 18px;

  h3 {
    align-items: center;
    display: flex;
    font-size: 16px;
    gap: 8px;
    margin: 0 0 6px;
  }

  p {
    color: rgba(255, 255, 255, 0.58);
    font-size: 12px;
    line-height: 1.45;
    margin: 0 0 14px;
  }

  .form-grid {
    display: grid;
    gap: 14px;
  }
`;

const FlowStyledOwn = styled(FlowStyled)`
  background: rgba(255, 255, 255, 0.025);
  border: 1px solid rgba(255, 255, 255, 0.05);
  border-radius: 8px;
  font-size: 13px;
  margin: 0;
  padding: 18px;
  width: 100%;

  h3 {
    font-size: 16px;
    margin: 0 0 10px;
    text-align: left;
  }
`;

const CreateNewMongoMonitorComponent = () => {
    const history = useHistory();

    const [name, setName] = useState("");
    const [connectionString, setConnectionString] = useState("");
    const [allDisabled, setAllDisabled] = useState(false);
    const [isSending, setIsSending] = useState(false);

    const handleSubmit = async () => {
        if (isSending) {
            return;
        }
        setAllDisabled(true);
        setIsSending(true);

        const payload = {
            name,
            connectionString
        };

        try {
            await mongoDbStore.create(payload);
            history.push("/servers");
        } catch (error) {
            addToast(error.message || 'Failed to create Mongo monitor', 'error');
            setAllDisabled(false);
            setIsSending(false);
        }
    };

    return (
        <BoxedStyledOwn>
            <SetupGridStyled>
                <FormCardStyled>
                    <h3><EuiIcon type="logoMongodb" size="m"/> Mongo connection</h3>
                    <p>Use a read-only connection string. Sensitive connection details are not displayed back in the UI.</p>
                    <div className="form-grid">
                        <EuiFormRow fullWidth={ true } label="Monitor name">
                            <EuiFieldText
                                fullWidth={ true }
                                value={ name }
                                disabled={ allDisabled }
                                isInvalid={ !name }
                                placeholder="Production Mongo"
                                onChange={ e => setName(e.target.value) }
                            />
                        </EuiFormRow>
                        <EuiFormRow fullWidth={ true } label="MongoDB connection string">
                            <EuiFieldText
                                fullWidth={ true }
                                value={ connectionString }
                                disabled={ allDisabled }
                                isInvalid={ !connectionString }
                                placeholder="mongodb://readonly:password@host:27017/admin"
                                onChange={ e => setConnectionString(e.target.value) }
                            />
                        </EuiFormRow>

                        <EuiButton
                            isDisabled={ !name || !connectionString || allDisabled }
                            size="s"
                            color={ "success" }
                            iconType="plusInCircle"
                            onClick={ handleSubmit }
                            fill
                            isLoading={ isSending }
                        >Create Mongo monitor</EuiButton>
                    </div>
                </FormCardStyled>
                <FlowStyledOwn>
                    <h3>Setup flow</h3>
                    <ul>
                        <li>Create a read-only user in your MongoDB database.</li>
                        <li>Prepare a MongoDB connection string for that user.</li>
                        <li>Name the monitor and paste the connection string.</li>
                        <li>Wait for the first MongoDB metrics payload.</li>
                    </ul>
                </FlowStyledOwn>
            </SetupGridStyled>
        </BoxedStyledOwn>
    );
};

export default CreateNewMongoMonitorComponent;
